module.exports = __webpack_public_path__ + "img/postgres.bea3a351.png";